// CMS-supplied hrefs are emitted verbatim - do NOT swap this for @repo/ui/navigation.
// The CMS localizes its own URLs (e.g. "cl/es/centro-de-ayuda/") and also returns
// external/relative ones, so prefixing here would double or corrupt the locale.
import Link from "next/link";

const links = [
  { label: "National destinations", href: "/destinations/national" },
  { label: "International destinations", href: "/destinations/international" },
  { label: "Discover our offers", href: "/offers" },
  { label: "Where to fly", href: "/destinations" },
  { label: "Travel magazine", href: "/magazine" },
];

export function MobileLinks() {
  return (
    <div
      className="flex flex-col justify-center space-y-3 md:hidden"
      data-testid="mobile-links-section"
    >
      {links.map(({ label, href }) => (
        <div
          key={label}
          className="text-brand-blue flex items-center gap-3 text-sm"
          data-testid="mobile-links-item"
        >
          <Link href={href} className="" data-testid="mobile-links-link">
            {label}
          </Link>
        </div>
      ))}
    </div>
  );
}
